// extracted by mini-css-extract-plugin
export default {"imgbox":"SubBanner_imgbox__4YI0c","center":"SubBanner_center__czfr0","head":"SubBanner_head__2KNxv","subHead":"SubBanner_subHead__t7tG2"};